import { render, staticRenderFns } from "./ModalBulkReturn.vue?vue&type=template&id=1a2234ee&scoped=true"
import script from "./ModalBulkReturn.vue?vue&type=script&lang=js"
export * from "./ModalBulkReturn.vue?vue&type=script&lang=js"
import style0 from "./ModalBulkReturn.vue?vue&type=style&index=0&id=1a2234ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2234ee",
  null
  
)

export default component.exports